import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core';
import { Layer, Source } from 'react-mapbox-gl';
import UncoveredArea from './UncoveredArea';
import { MapGeometryExact } from '../../models/MapGeometry';

const UncoveredAreas = ({ uncoveredAreas }) => {
  const theme = useTheme();

  const visible = useMemo(() => {
    if (uncoveredAreas.length < 1) return false;
    return uncoveredAreas[0].visible;
  }, [uncoveredAreas]);

  return (
    <>
      <Source id="overlay" />
      {visible && (
        <Layer id="overlay" type="background" source="overlay" paint={{ 'background-color': theme.palette.common.black, 'background-opacity': 0.7 }} />
      )}

      {uncoveredAreas.map(({ coordinates }, index) => (
        <UncoveredArea key={String(index)} index={index} coordinatesArray={coordinates} visible={visible} />
      ))}
    </>
  );
};

UncoveredAreas.propTypes = {
  uncoveredAreas: PropTypes.arrayOf(MapGeometryExact),
};

UncoveredAreas.defaultProps = {
  uncoveredAreas: [],
};

export default React.memo(UncoveredAreas);
